import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {isElementUnderPoint, SanitizeClassNames} from '../common';
import './BiopedUI.css';

const bodyNode = document.getElementsByTagName('body')[0];
const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;

export class BioPortal extends Component{

	render(){
		if(this.props.isVisible === true){
			let domNode = this.props.mountNode || bodyNode;
			return ReactDOM.createPortal(
				this.props.children,
				domNode
			);
		}
		return null;
	}
}

export class BioTrackPortal extends Component{
	container = null;
	timerId = null;
	containerStyle = {
		position: 'fixed'
	}
	componentDidMount(){
		this.startTracking();
	}

	componentWillUnmount(){
		this.stopTracking();
	}

	componentDidUpdate(){
		this.startTracking();
	}

	_checkMouseOut = (e)=>{
		// console.log('_checkMouseOut:', e);
		let x = e.x;
		let y = e.y;
		if(!isElementUnderPoint(this.container, x, y) && this.props.onClickOutside){
			this.props.onClickOutside(x, y);
		}
		//console.log('iS Element under Point:', );
	}

	startTracking(){
		//console.log("Start Tracking:", this.props.target);
		this.stopTracking();
		if(this.updatePosition()){
			bodyNode.addEventListener("mousedown", this._checkMouseOut);
		}

	}

	stopTracking(){
		cancelAnimationFrame(this.timerId);
		bodyNode.removeEventListener('mousedown', this._checkMouseOut);
	}

	updatePosition = () => {
		if(!this.props.target || !this.container)return false;

		let bounds = this.props.target.getBoundingClientRect();

		let container = this.container;
		let ox = this.props.xOffset || '0px';
		let oy = this.props.yOffset || '0px';

		//console.log("Target:", this.props.target, '  Bounds:', bounds);

		container.style.top = 'calc(' + bounds.bottom + 'px + ' + oy + ')';
		container.style.left = 'calc(' + bounds.left + 'px + ' + ox + ')';

		if(this.props.posFunc){
			this.props.posFunc(container.style, bounds, container, this.arrow.style);
		}

		this.timerId = requestAnimationFrame(this.updatePosition);
		return true;
	}

	handleContainerRef = (ref) => {
		this.container = ref;
	}
	handleArrowRef = (ref) => {
		this.arrow = ref;
	}

	render(){
		return(
			<BioPortal mountNode={this.props.mountNode} isVisible={this.props.isVisible}><div ref={this.handleContainerRef} className={SanitizeClassNames(this, 'bio-track-portal')} style={this.containerStyle}><div className='popover-hover-arrow' ref={this.handleArrowRef}></div>{this.props.children}</div></BioPortal>
		)
	}
}

export class BioDropDown extends Component{
	labelRef = null;
	state = {isOpen:false};
	handleRef = (ref) => {
		this.labelRef = ref;
	}

	handleClick = () =>{
		this.setState({isOpen:!this.state.isOpen});
	}

	handleClickOutside = (x, y) => {
		if(!isElementUnderPoint(this.labelRef, x, y))this.setState({isOpen: false});
	}

	render(){
		return(
			<div className={ SanitizeClassNames(this, 'bio-dropdown') }>
				<div ref={this.handleRef} onMouseDown={this.handleClick}>{this.props.label}</div>
				{this.state.isOpen? <BioTrackPortal isVisible={true} target={this.labelRef} xOffset={this.props.xOffset} yOffset={this.props.yOffset} onClickOutside={this.handleClickOutside} >{this.props.children}</BioTrackPortal>:null}
			</div>
		)
	}
}

export class LoadingSpinner extends Component{
	render(){
		return(<span className={SanitizeClassNames(this, 'load-spinner')}><span className="Select-loading"></span></span>);
	}
}



// WEBPACK FOOTER //
// ./src/components/BiopedUI.js